import { Loader } from "@mantine/core";
import { forwardRef } from "react";

export const NavSectionLoadingItem = forwardRef<HTMLDivElement>((_, ref) => {
	return (
		<div className="flex items-center justify-center h-8 w-full" ref={ref}>
			<Loader color="var(--ui-color-brand-primary)" type="dots" />
		</div>
	);
});
